/*eslint-disable*/ export const messages = {
    Apply: "Applica",
    Clear: "Clear",
    "Date picker open, choose a date": "Selezionatore di data aperta, scegliere una data",
    "Date range picker open, select a date range": "Selezionatore di data aperta, selezionare intervallo di date",
    "End Date": "Data di fine",
    "Please enter a date ({format})": ["Inserire una data (", ["format"], ")"],
    "Please select a date after {minDate}": ["Seleziona una data dopo ", ["minDate"]],
    "Please select a date before {maxDate}": ["Seleziona una data prima ", ["maxDate"]],
    "Show next month": "Mostrare il prossimo mese",
    "Show previous month": "Mostrare mese precedente",
    "Start Date": "Data di inizio",
    "The selected date is disabled": "La data selezionata è disabilitata",
    "The selected date is unavailable. Please select another.":
        "La data selezionata non è disponibile, Sceglierne un’altra",
    Today: "Today",
    "Today, {dateStr}": ["Oggi, ", ["dateStr"]],
    "date picker": "Selezionatore di data",
    "start date selected": "data inizio selezionata",
    to: "to",
    "{dateStr}, select end date": [["dateStr"], ", selezionare data fine"],
    "{dateStr}, select start date": [["dateStr"], ", selezionare data inizio"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        " a ",
        ["endDate"],
        ", scegliere applica per confermare o cancella",
    ],
};
